import React from "react"
import { Col, Container, Row } from "reactstrap"
import pic1 from "assets/images/about3.png"
import pic2 from "assets/images/about2.png"
import Charity from "assets/images/charity.png"
import Faq from "./Faq"
import HowItWorks from "../../HomePage/components/HowItWorks"
export default function About() {
  return (
    <div className="overflow-hidden">
      <section id="about-page" className=" pb-2 pb-lg-5 px-2 px-lg-2">
        <div className="px-2 pb-2 pb-lg-5">
          <h2 className="ff-cooper text-uppercase font-size-56 fw-normal blue-text-color mt-2 pt-4 pt-md-0 mt-lg-5 px-2 px-md-5 ">
            we are the dockies
          </h2>
          <Row className="d-flex align-items-center w-100 justify-content-between g-1 g-md-5 px-0 px-md-5 py-2 py-md-5">
            <Col
              lg={6}
              className=" 
            "
            >
              <img src={pic1} alt="Image Alt" className="img-fluid" />
            </Col>
            <Col lg={6} className=" ps-0 ps-md-5 my-0 my-md-5">
              <h3 className="font-size-32 fw-bolder  black-text-color ff-proxima pt-3 pt-md-0">
                Our Mission: to give the greater community a point of connection
                for family, friends, and laughter
              </h3>
              <p className="about-text-clamp overflow-hidden ff-proxima font-size-18 fw-normal  ">
                When we started Dock Tok in 2020, it was really just a couple of
                mustaches joking around on our hometown’s dock. Little did we
                know the impact our “silly jokes” would have on a world in need
                of a good old fashioned laugh.Fast forward 3 years, 8 million
                fans, and over 1 billion video views later….we are ready to
                share the dock
              </p>
            </Col>
          </Row>
        </div>
      </section>
      <section id="about-page" className="  bg-light-skin">
        <Container fluid>
          <Row className="justify-content-center g-0 g-md-5 px-0 px-md-5 py-5">
            <Col xs={12} lg={12} className="text-lg-center">
              <h1 className=" ff-cooper text-uppercase font-size-56 fw-normal blue-text-color ">
                Welcome to The Dockies
              </h1>

              <p className="ff-proxima font-size-18 fw-normal">
                It’s your turn to share your humor and creativity with the world
                as you showcase your best dad jokes in our global community. We
                can’t wait to laugh together as YOU take the spotlight at The
                Dockies. After receiving countless DMs, comments, and emails
                with hilarious jokes and requests from our Dock Tok fans, we
                created a place for YOU to share YOUR best dad jokes for the
                chance to win monthly prizes and be featured on Dock Tok social
                media <b>@loganlisle</b>. Grab your friends, pull up a chair,
                and we’ll see you on The Dock
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <HowItWorks />
      <section
        id="about-page  "
        className="bg-light-skin px-2 px-lg-2 pb-0 pb-lg-5"
      >
        <div className="px-2 ">
          <Row className="d-flex align-items-center w-100 justify-content-between g-1 g-md-5 px-0 px-md-5 py-5">
            <Col
              lg={6}
              className=" 
            "
            >
              <img src={Charity} alt="Image Alt" className="img-fluid" />
            </Col>
            <Col lg={6} className=" ps-0 ps-md-5 my-0 my-md-5">
              <h3 className="font-size-32 fw-bolder  black-text-color ff-proxima pt-3 pt-md-0">
                5 percent of the revenue earned by this site will go to the
                single parents
              </h3>
              <p className="about-text-clamp overflow-hidden ff-proxima font-size-18 fw-normal  ">
                Lorem ipsum dolor sit amet consectetur adipiscing elit Ut et
                massa mi. Aliquam in hendrerit urna. Pellentesque sit amet
                sapien fringilla, mattis ligula consectetur, ultrices mauris.
                Maecenas vitae mattis tellus. Nullam quis imperdiet augue.
                Vestibulum auctor ornare leo, non suscipit magna interdum eu.
                Curabitur pellentesque nibh nibh, at maximus ante.
              </p>
            </Col>
          </Row>
        </div>
      </section>

      <section className="bg-light ">
        <Container fluid className="py-5">
          <Row className="g-0 g-md-5 px-0 px-md-5 py-0 py-md-5">
            <Col md={12}>
              <div className="pt-4 pb-4  ">
                <Faq />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  )
}
